import { render, staticRenderFns } from "./detail_dzda.vue?vue&type=template&id=4700400c&scoped=true"
import script from "./detail_dzda.vue?vue&type=script&lang=js"
export * from "./detail_dzda.vue?vue&type=script&lang=js"
import style0 from "./detail_dzda.vue?vue&type=style&index=0&id=4700400c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700400c",
  null
  
)

export default component.exports